import ElTableExtendControl from '../table-extend/src/table-extend-control';

/* istanbul ignore next */
ElTableExtendControl.install = function(Vue) {
  Vue.component(ElTableExtendControl.name, ElTableExtendControl);
};

export default ElTableExtendControl;



// WEBPACK FOOTER //
// ./packages/table-extend-control/index.js